import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import React from 'react';
import * as CSS from './elements/Students';

// shown to students in place of the message form once work is complete
const CompleteNote = ({ resource }) => (
  <CSS.CompleteNote data-testid="CompleteNote">
    <LockOutlinedIcon aria-hidden="true" style={{ fontSize: '2rem' }} />
    This {resource} is complete. Your teacher will reopen it if anything needs
    changing.
  </CSS.CompleteNote>
);

export default CompleteNote;
